
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
} from '@coreui/react-pro'

import FormTextInput from './FormTextInput'
import FormPhoneNumber from './FormPhoneNumber'
import FormTextAreaInput from './FormTextAreaInput'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'
import TrashIcon from '../../../assets/icons/TrashIcon.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormOtherPIC = ({
  colSize,
  inputLabel,
  className,
  countryOptions,
  othersPIC,
  handleAddOthersPIC,
  handlePhoneCountry,
  errors,
  handleChange,
  disabled,
  handleRemoveOthersPIC,
  isDetail
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel className='fs-6 fs-md-3'>
          {inputLabel}
        </CFormLabel>
      </div>
      {othersPIC?.length > 0 ? (
        othersPIC?.map((inputField, index) => {
          return (
            <CRow className="mb-4">
              <FormTextInput 
                id='name'
                name='name'
                colSize='6'
                className='mb-3'
                inputLabel='Name'
                placeholder='Enter point of contact name...'
                value={inputField?.name}
                handleTextInput={(e) => handleChange(e, index)}
                feedbackInvalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.name}
                invalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.name}
                disabled={isDetail}
              />
              <FormPhoneNumber
                colSize='6'
                className='mb-3'
                inputLabel='Phone Number'
                placeholder='Enter point of contact phone number...'
                countryOptions={countryOptions}
                country={inputField?.country_value}
                value={inputField}
                handlePhoneNumber={(e) => handleChange(e, index)}
                handlePhoneCountry={(e) => handlePhoneCountry(e, index)}
                errors={errors?.others_pic?.length > 0 && errors?.others_pic[index]}
                disabled={isDetail}
              />
              <FormTextInput 
                id='position'
                name='position'
                colSize='6'
                inputLabel='Job Position'
                className='mb-3'
                placeholder='Enter point of contact job position...'
                value={inputField?.position}
                handleTextInput={(e) => handleChange(e, index)}
                feedbackInvalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.position}
                invalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.position}
                handleClickButton={handleAddOthersPIC}
                disabled={isDetail}
              />
              <FormTextInput 
                id='email'
                name='email'
                colSize='6'
                inputLabel='Email Address'
                className='mb-3'
                placeholder='Enter point of contact email address...'
                value={inputField?.email}
                handleTextInput={(e) => handleChange(e, index)}
                feedbackInvalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.email}
                invalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.email}
                handleClickButton={handleAddOthersPIC}
                disabled={isDetail}
              />
              <FormTextInput 
                id='department'
                name='department'
                colSize='6'
                inputLabel='Department/Division'
                className='mb-3'
                placeholder='Enter point of contact department/division...'
                value={inputField?.department}
                handleTextInput={(e) => handleChange(e, index)}
                feedbackInvalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.department}
                invalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.department}
                handleClickButton={handleAddOthersPIC}
                disabled={isDetail}
              />
              <FormTextAreaInput
                id='additional_notes'
                name='additional_notes'
                colSize='6'
                inputLabel='Additional Notes'
                className='mb-3'
                placeholder='Enter point of contact additional notes...'
                rows='5'
                value={inputField?.additional_notes}
                handleTextAreaInput={(e) => handleChange(e, index)}
                feedbackInvalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.additional_notes}
                invalid={errors?.others_pic?.length > 0 && errors?.others_pic[index]?.additional_notes}
                disabled={isDetail}
              />
              <CCol lg={1}>
                {
                  othersPIC?.length > 0 && !disabled && (
                    <CButton
                      style={styleButtonVars2}
                      onClick={() => {handleRemoveOthersPIC(inputField, index)}}
                    >
                      Delete
                    </CButton>
                  )
                }
              </CCol>
            </CRow>
          )
        })
      ) : !isDetail ? (
        <div className='alert alert-secondary'><b>You can add other Point of Contact (PoC) client</b></div>
      ) : (
        <div className='alert alert-secondary'><b>You not have other Point of Contact (PoC) client</b></div>
      )}
    </CCol>
  )
}

export default FormOtherPIC
